import { msalApp, requiresInteraction, isIE, GRAPH_SCOPES, GRAPH_REQUESTS } from './auth-utils';
import { UATConstants } from './Common/Models/UATConstants';
import { appInsights } from 'src/Services/Insights';
import { GetUserAppInsightProperties } from 'src/utils/AppInsightProperties';

// If you support IE, our recommendation is that you sign-in using Redirect APIs
const useRedirectFlow = isIE();

export const acquireToken = async (request, redirect) => {
  const isIframe = window !== window.parent && !window.opener;
  if (window.self !== window.top && isIframe) {
    setTimeout(function () {
      console.log('waited 30 sec');
    }, 30000);
  } else {
    var bearerToken = await msalApp.acquireTokenSilent(request).catch(async (error) => {
      // Call acquireTokenPopup (popup window) in case of acquireTokenSilent failure
      // due to consent or interaction required ONLY
      if (requiresInteraction(error.errorCode)) {
        return await msalApp.acquireTokenRedirect(request);
      } else {
        console.error('Non-interactive error:', error.errorCode);
        return await msalApp.acquireTokenRedirect(request);
      }
    });

    return bearerToken;
  }
};

export const onTokenRenewal = async (refreshtoken) => {
  //refresh Graph token
  if (refreshtoken === UATConstants.PlaceholdersAndTitles.Graph) {
    const graphTokenResponse = await acquireToken(GRAPH_REQUESTS.LOGIN, isIE()).catch((error) => {
      this.setState({
        error: error.message,
      });
      appInsights.trackEvent(
        {
          name: UATConstants.Telemetry.GraphTokenRenewalFailed,
        },
        GetUserAppInsightProperties()
      );
      appInsights.trackException({ exception: new Error(error.message) });
    });

    if (graphTokenResponse) {
      sessionStorage.setItem(UATConstants.jwtTokenForGraph, graphTokenResponse.accessToken);
      sessionStorage.setItem(UATConstants.graphTokenExpiryTime, graphTokenResponse.expiresOn);
      window.dispatchEvent(new Event('storage'));
      appInsights.trackEvent(
        {
          name: UATConstants.Telemetry.TokenRenewalGraph,
        },
        GetUserAppInsightProperties()
      );
      if (graphTokenResponse && graphTokenResponse.scopes.indexOf(GRAPH_SCOPES.MAIL_READ) > 0) {
        return this.readMail(graphTokenResponse.accessToken);
      }
    }
  }

  //ADO token
  if (refreshtoken === UATConstants.PlaceholdersAndTitles.Devops) {
    const graphTokenResponse = await acquireToken(GRAPH_REQUESTS.DevopsAPI, isIE()).catch(
      (error) => {
        this.setState({
          error: error.message,
        });
        appInsights.trackEvent(
          {
            name: UATConstants.Telemetry.DevopsTokenRenewalFailed,
          },
          GetUserAppInsightProperties()
        );
        appInsights.trackException({ exception: new Error(error.message) });
      }
    );

    if (graphTokenResponse) {
      sessionStorage.setItem(UATConstants.jwtTokenForADOApi, graphTokenResponse.accessToken);
      sessionStorage.setItem(UATConstants.devopsTokenExpiryTime, graphTokenResponse.expiresOn);
      appInsights.trackEvent(
        {
          name: UATConstants.Telemetry.TokenRenewalGraph,
        },
        GetUserAppInsightProperties()
      );
    }
  }

  //refresh Core token
  if (refreshtoken === UATConstants.PlaceholdersAndTitles.Core) {
    const coreTokenResponse = await acquireToken(GRAPH_REQUESTS.CoreAPI, true).catch((e) => {
      this.setState({
        error: 'Unable to acquire access token for API.',
      });
      appInsights.trackEvent(
        {
          name: UATConstants.Telemetry.CoreTokenRenewalFailed,
        },
        GetUserAppInsightProperties()
      );
      appInsights.trackException({ exception: new Error(e.message) });
    });

    if (coreTokenResponse) {
      sessionStorage.setItem(UATConstants.jwtTokenForCoreApi, coreTokenResponse.accessToken);
      sessionStorage.setItem(UATConstants.coreTokenExpiryTime, coreTokenResponse.expiresOn);

      appInsights.trackEvent(
        {
          name: UATConstants.Telemetry.TokenRenewalCORE,
        },
        GetUserAppInsightProperties()
      );
    }
  }

  //refresh API token
  if (refreshtoken === UATConstants.PlaceholdersAndTitles.Api) {
    const tokenResponse = await acquireToken(GRAPH_REQUESTS.API, useRedirectFlow).catch((e) => {
      this.setState({
        error: 'Unable to acquire access token for API.',
      });
      appInsights.trackEvent(
        {
          name: UATConstants.Telemetry.APITokenRenewalFailed,
        },
        GetUserAppInsightProperties()
      );
      appInsights.trackException({ exception: new Error(e.message) });
    });

    if (tokenResponse) {
      sessionStorage.setItem(UATConstants.loginTokenExpiryTime, tokenResponse.expiresOn);
      sessionStorage.setItem(UATConstants.jwtTokenForApi, tokenResponse.accessToken);
      window.dispatchEvent(new Event('storage'));
      appInsights.trackEvent(
        {
          name: UATConstants.Telemetry.TokenRenewalAPI,
        },
        GetUserAppInsightProperties()
      );
    }
  }
};
